import { Theme } from '@mui/material';

export const sidebarDrawerStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    py: 2,
    height: '100vh',
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  mobileContainer: {
    backgroundColor: 'var(--menu-app-bar)',
  },
  headerBox: (sidebarOpen: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    maxHeight: '30px',
    justifyContent: sidebarOpen ? 'flex-start' : 'center',
    gap: sidebarOpen ? '8px' : '0px',
    px: sidebarOpen ? '24px' : '10px',
    cursor: 'pointer',
  }),
  headerBoxMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 1,
  },
  headerTypography: (sidebarOpen: boolean) => ({
    fontWeight: 900,
    fontSize: sidebarOpen ? '20px' : '18px',
    color: 'primary.main',
    whiteSpace: 'pre-line',
  }),
  listItemButton: {
    padding: '8px 24px',
    transition: 'all 0.2s ease-in-out',
    '&:hover, &.active': {
      color: 'primary.main',
    },
    '&:hover .MuiListItemIcon-root, &:hover .MuiTypography-root': {
      color: 'primary.main',
    },
  },
  listItemButtonContent: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  listItemButtonMobile: {
    padding: '8px 24px',
    transition: 'all 0.2s ease-in-out',
    '&.active': {
      color: 'primary.main',
    },
  },
  listItemIcon: (isActive: boolean) => ({
    color: isActive ? 'primary.main' : 'var(--table-header-bg-dark)',
  }),
  listItemIconMobile: (isActive: boolean) => ({
    color: isActive ? 'primary.main' : 'background.paper',
  }),
  listItemText: (isActive: boolean) => ({
    fontWeight: 600,
    color: isActive ? 'primary.main' : 'var(--paper)',
    padding: '8px 0',
  }),
  listItemTextMobile: (isActive: boolean) => ({
    fontWeight: 600,
    color: isActive ? 'primary.main' : 'background.paper',
    padding: '8px 0',
  }),
  sidebarDrawerOpenIcon: (theme: Theme, sidebarOpen: boolean) => ({
    position: 'fixed',
    background: 'var(--primary)',
    color: 'background.paper',
    left: sidebarOpen ? '225px' : '59px',
    top: '25px',
    padding: 0,
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: sidebarOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
    }),
    '&:hover': {
      background: 'var(--primary)',
      color: 'background.paper',
    },
  }),
};
